export class UrlsConstants {  
  public static MONITOR_PATH = 'monitor';
  
  public static LOGIN_PATH = 'login';
  public static LOGIN_SGC1_PATH = 'login/sgc1';

  public static HOME_PATH = 'home';

  public static MAINTENACE_PATH = 'maintenance';
  public static FAMILIES_PATH = 'families';
  public static FAMILY_PATH = 'family';
  public static FAMILY_ADD_PATH = 'family-add';

  public static CONTRACTS_PATH = 'contracts';

  public static SCHOOLS_PATH = 'schools';
  public static SCHOOL_PATH = 'school';

  public static REPORTS_PATH = 'reporting';

  public static INVOICE_TEMPLATES_PATH = 'invoice-templates';
  public static INVOICE_TEMPLATE_PATH = 'invoice-template';

  public static ATTENDANCE_PATH = 'attendance';
  public static ATTENDANCE_CAU_PATH = 'attendance-cau';
  public static ATTENDANCES_CAU_PATH = 'attendances-cau';
}
